import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormArray } from '@angular/forms';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { OverrideRule } from '../../../../shared/models/overrideRule';
import { OverrideRuleService } from '../../../../shared/services/overrideRule.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AgeRange } from '../../../models/ageRange';
import { AgeRangeService } from '../../../services/ageRange.service';
import { StoreLocationService } from '../../../services/storelocation.service';
import { StoreLocation } from '../../../models/storeLocation';
import { CampaignType } from '../../../models/CampaignType';
import { CampaignTypeService } from '../../../services/campaignType.service';
import { ValidationService } from '../../../services/validation.service';
import { Field } from '../../../models/field';

@Component({
  selector: 'app-override-rule-add-form',
  templateUrl: './override-rule-add.component.html'
})

export class OverrideRuleAddFormComponent implements OnInit { 

  //input/output parameters
  @Input() title;
  @Input() brandId: number;
  @Input() model: OverrideRule;

  editForm: FormGroup; 
  submitted = false;  
  public ageRangeList: AgeRange[];  
  public genderList = ['F', 'M'];
  public storeLocationList: StoreLocation[];
  public campaignTypeList: CampaignType[];
  public fieldNames: string[] = ['FrontImage', 'FrontCTA', 'FrontOffer', 'FrontLogo', 'BackLogo', 'BackCTA', 'BackBackground', 'BackBottomLeftCopy', 'BackOfferBlock', 'BackStoreBlock', 'Style', 'Custom1', 'Custom2', 'Custom3', 'Custom4', 'Custom5','StoreDescription'];
  fields: FormArray;
  public startDate: Date;
  public endDate: Date;

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private overrideRuleService: OverrideRuleService,
    private ageRangeService: AgeRangeService,
    private storeLocationService: StoreLocationService,
    private notification: MatSnackBar,
    private campaignTypeService: CampaignTypeService) { }


  // on component load
  ngOnInit() {  
    // bind age ranges dropdown
    this.ageRangeService.getAll().subscribe(result => {
      this.ageRangeList = result;
    });

    // bind campaign dropdown
    this.campaignTypeService.getAll().subscribe(result => {
      this.campaignTypeList = result;
    });

    // bind store locations dropdown
    this.storeLocationService.getAll(this.brandId).subscribe(result => {
      this.storeLocationList = result;
    });
     
    if (this.model === undefined) {

      // build empty form model
      this.editForm = this.formBuilder.group({
        gender: null,
        months: ['', ValidationService.numericValidator],
        brandId: this.brandId,
        campaignTypeId: 0,
        storeLocationId: 0,
        ageRangeId: [0, [Validators.required, Validators.min(1)]],
        priority: [0, [Validators.required, Validators.min(0)]],
        startDate: ['', Validators.required],
        endDate: ['', Validators.required],
        custom1: null,
        custom2: null,
        custom3: null,
        custom4: null,
        custom5: null,
        fields: this.formBuilder.array([this.createItem()])
      });
    }
    else {
    // build form model from copy

      // init dates
      this.startDate = new Date(this.model.startDate);
      this.endDate = new Date(this.model.endDate);

      const formGroups = this.model.fields.map(x => this.formBuilder.group({
        name: [x.name, Validators.required],
        value: [x.value, Validators.required]
      }));

      this.editForm = this.formBuilder.group({
      gender: this.model.gender || null,
      months: [this.model.months || '', ValidationService.numericValidator],
      brandId: this.brandId,
      campaignTypeId: this.model.campaignTypeId || 0,
      storeLocationId: this.model.storeLocationId || 0,
      ageRangeId: [this.model.ageRangeId || 0, [Validators.required, Validators.min(1)]],
      priority: [this.model.priority || 0, [Validators.required, Validators.min(0)]],
      startDate: [this.startDate , Validators.required],
      endDate: [this.endDate , Validators.required],
      custom1: this.model.custom1 || null,
      custom2: this.model.custom2 || null,
      custom3: this.model.custom3 || null,
      custom4: this.model.custom4 || null,
      custom5: this.model.custom5 || null, 
      fields: this.formBuilder.array(formGroups)
    });
    }
  }
    
  createItem(): FormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
      value: ['', Validators.required] 
    });
  }

  // handle form submit 
  onSubmit() {
      this.submitted = true;
      
      // stop here if form is invalid
      if (this.editForm.invalid) {
        return; 
      } 
      const model = this.editForm.value as OverrideRule;
      model.brandId = +this.editForm.value['brandId'];
      model.campaignTypeId = +this.editForm.value['campaignTypeId'];
      model.storeLocationId = +this.editForm.value['storeLocationId'];
      model.ageRangeId = +this.editForm.value['ageRangeId'];
      model.months = +this.editForm.value['months'];
      model.priority = +this.editForm.value['priority'];
      
      this.overrideRuleService.add(model).subscribe(overrideRule => {       
        //this.eventEmitter.emit(this.editForm.value);
        this.activeModal.close(true);
        this.showNotification(`The entry was successuly updated!`, 'Okay!');
      }); 
  }

  decline(): void {
    this.activeModal.close(false);
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

  // display notifications
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
  }

  // remove field
  removeFieldName(i): void {
    this.fields.removeAt(i);
  }

  // add field
  addFieldName(): void {
    this.fields = this.editForm.get('fields') as FormArray;
    this.fields.push(this.createItem());
  }
}
